/* ═══════════════════════════════════════════════════════════════════════
   KI-CART-DRAWER — state check + the one upsell card + per-line dose pills
   for snippets/cart-drawer.liquid (Kraft & Ink, 2026-10-03). Moved out of
   the inline <script> so it caches. Self-contained: theme.js keeps its
   renderer private, so this watches [data-cart-body] (MutationObserver),
   re-fetches /cart.js after each render and rebuilds what it owns. All
   text lands via textContent; product data comes from the live
   /products/{handle}.js JSON and the cart's own cents — never literals.

   Listens: cc:state (document), storage (cc_state), MutationObserver on
            [data-cart-body].
   Emits:   cc:state { state, ship, source: 'cart-drawer' } on select
            cc:analytics: state_select, state_rescue_shown, state_rescue_swap,
            state_notify_submit, cart_ritual_shown, cart_upgrade_shown,
            cart_upgrade
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__ccsrDrawer) return;
  window.__ccsrDrawer = true;

  var root = document.querySelector('[data-ccsr-drawer]');
  var merch = document.querySelector('[data-cart-merch]');
  var cartBody = document.querySelector('[data-cart-body]');
  if (!root || !merch || !cartBody) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-ccsr-config]').textContent); } catch (e) { cfg = {}; }

  var STATES = { AL:'Alabama', AK:'Alaska', AZ:'Arizona', AR:'Arkansas', CA:'California', CO:'Colorado', CT:'Connecticut', DE:'Delaware', DC:'Washington, D.C.', FL:'Florida', GA:'Georgia', HI:'Hawaii', ID:'Idaho', IL:'Illinois', IN:'Indiana', IA:'Iowa', KS:'Kansas', KY:'Kentucky', LA:'Louisiana', ME:'Maine', MD:'Maryland', MA:'Massachusetts', MI:'Michigan', MN:'Minnesota', MS:'Mississippi', MO:'Missouri', MT:'Montana', NE:'Nebraska', NV:'Nevada', NH:'New Hampshire', NJ:'New Jersey', NM:'New Mexico', NY:'New York', NC:'North Carolina', ND:'North Dakota', OH:'Ohio', OK:'Oklahoma', OR:'Oregon', PA:'Pennsylvania', RI:'Rhode Island', SC:'South Carolina', SD:'South Dakota', TN:'Tennessee', TX:'Texas', UT:'Utah', VT:'Vermont', VA:'Virginia', WA:'Washington', WV:'West Virginia', WI:'Wisconsin', WY:'Wyoming' };

  function parseList(s) {
    var out = [];
    String(s || '').toUpperCase().split(/[^A-Z]+/).forEach(function (c) {
      if (STATES[c] && out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }
  var BANNED = parseList(cfg.banned);
  var BLOCKED10 = parseList(cfg.blocked10);
  var CONFIGURED = BANNED.length > 0 || BLOCKED10.length > 0;
  var STORE_OPEN = merch.getAttribute('data-store-open') !== 'false';

  /* ── State store (age-gate contract) ── */
  var memState = '';
  function getState() {
    try { return localStorage.getItem('cc_state') || ''; } catch (e) { return memState; }
  }
  function setState(code) {
    memState = code;
    try { if (code) { localStorage.setItem('cc_state', code); } else { localStorage.removeItem('cc_state'); } } catch (e) {}
    var ship = code ? (BANNED.indexOf(code) !== -1 ? 'blocked' : (BLOCKED10.indexOf(code) !== -1 ? 'cbd-only' : 'ok')) : null;
    try {
      window.ccState = code || null;
      window.ccShip = ship;
      if (code) {
        document.documentElement.setAttribute('data-cc-state', code);
        document.documentElement.setAttribute('data-cc-ship', ship);
        localStorage.setItem('cc_ship', ship);
        document.cookie = 'cc_state=' + encodeURIComponent(code) + '; max-age=31536000; path=/; SameSite=Lax';
      } else {
        document.documentElement.removeAttribute('data-cc-state');
        document.documentElement.removeAttribute('data-cc-ship');
        localStorage.removeItem('cc_ship');
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cc:state', { detail: { state: code, ship: ship, source: 'cart-drawer' } })); } catch (e) {}
  }
  function track(name, props) {
    try { document.dispatchEvent(new CustomEvent('cc:analytics', { detail: { name: name, props: props || {} } })); } catch (e) {}
  }
  function announce(text) {
    var live = document.querySelector('[data-cc-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  function fillTpl(el, code) {
    var name = STATES[code] || code;
    var scope = [];
    if (el.hasAttribute('data-tpl')) scope.push(el);
    el.querySelectorAll('[data-tpl]').forEach(function (n) { scope.push(n); });
    scope.forEach(function (n) { n.textContent = n.getAttribute('data-tpl').replace(/\{state\}/g, name); });
  }
  function moneyFromCents(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (lastCart && lastCart.currency) || 'USD' }).format(cents / 100); }
    catch (e) { return ''; }
  }
  function packNum(title) {
    var m = String(title || '').match(/(\d+)\s*-?\s*pack/i);
    return m ? parseInt(m[1], 10) : 0;
  }
  function article(n) { return /^(8|11|18)/.test(String(n)) ? 'an' : 'a'; }

  /* ── State select: shown only when no state is known yet ── */
  var select = root.querySelector('[data-ccsr-select]');
  var pick = root.querySelector('[data-ccsr-pick]');
  var known = root.querySelector('[data-ccsr-known]');
  var knownName = root.querySelector('[data-ccsr-known-name]');
  var changeBtn = root.querySelector('[data-ccsr-change]');
  var picking = false;
  Object.keys(STATES).sort(function (a, b) { return STATES[a] < STATES[b] ? -1 : 1; }).forEach(function (code) {
    var o = document.createElement('option');
    o.value = code; o.textContent = STATES[code];
    select.appendChild(o);
  });
  select.value = getState();
  function syncPicker() {
    var st = getState();
    var showPick = !st || picking;
    pick.hidden = !showPick;
    known.hidden = showPick;
    if (st && knownName) knownName.textContent = STATES[st] || st;
  }
  if (changeBtn) changeBtn.addEventListener('click', function () {
    picking = true; syncPicker(); select.focus();
  });
  select.addEventListener('change', function () {
    setState(select.value);
    track('state_select', { state: select.value, placement: 'cart_drawer' });
    picking = false;
    syncPicker();
    compute();
  });
  document.addEventListener('cc:state', function (e) {
    if (!e.detail || e.detail.source === 'cart-drawer') return;
    var code = e.detail.state || '';
    if (select.value !== code) select.value = code;
    syncPicker();
    compute();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === 'cc_state') { select.value = e.newValue || ''; syncPicker(); compute(); }
  });

  /* ── Cart classification (cart.js carries no metafields: handles) ── */
  var lastCart = null;
  var productCache = {};
  function isDn(h) { return (h || '').indexOf('day-and-night') !== -1; }
  function isHemp(h) { return /-infused|-microdose/.test(h || '') || isDn(h); }
  function isInfused(h) { return (h || '').indexOf('-infused') !== -1 || isDn(h); }
  function hempLines(c) { return c ? c.items.filter(function (i) { return isHemp(i.handle); }) : []; }
  function infusedLines(c) { return c ? c.items.filter(function (i) { return isInfused(i.handle); }) : []; }
  function worldOf(handle) {
    var h = String(handle || '');
    if (isDn(h)) return 'both';
    if (h.indexOf('canna-joe') !== -1) return 'joe';
    if (h.indexOf('canna-tini') !== -1) return 'tini';
    return '';
  }

  var host = root.querySelector('[data-ccsr-host]');
  var okEl = root.querySelector('[data-ccsr-ok]');
  var swaps = root.querySelector('[data-ccsr-swaps]');
  var cards = root.querySelector('[data-ccsr-swap-cards]');
  var bannedBox = root.querySelector('[data-ccsr-banned]');
  var notifyForm = root.querySelector('[data-ccsr-notify]');
  var notifyNote = root.querySelector('[data-ccsr-notify-note]');

  function compute() {
    computeMerch(lastCart);
    var st = getState();
    var hemp = hempLines(lastCart);
    root.hidden = hemp.length === 0;
    syncPicker();
    host.hidden = true; okEl.hidden = true; swaps.hidden = true; bannedBox.hidden = true;
    if (!lastCart || hemp.length === 0 || !st) return;
    if (BANNED.indexOf(st) !== -1) {
      host.hidden = false; bannedBox.hidden = false;
      fillTpl(bannedBox, st);
      var tags = bannedBox.querySelector('[data-ccsr-tags]');
      if (tags) tags.value = 'notify-state,state-' + st;
      track('state_rescue_shown', { state: st, kind: 'banned' });
    } else if (BLOCKED10.indexOf(st) !== -1 && infusedLines(lastCart).length) {
      host.hidden = false; swaps.hidden = false;
      fillTpl(swaps, st);
      buildSwapCards(infusedLines(lastCart), st);
      track('state_rescue_shown', { state: st, kind: 'swap' });
    } else if (CONFIGURED) {
      host.hidden = false; okEl.hidden = false;
      fillTpl(okEl, st);
    }
  }

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }
  function matchVariant(p, vt) {
    var vs = p.variants || [];
    var want = packNum(vt);
    var i;
    if (want) for (i = 0; i < vs.length; i++) { if (packNum(vs[i].title) === want && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++) { if (vs[i].title === vt && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++) { if (vs[i].available !== false) return vs[i]; }
    return null;
  }
  function doseFor(handle) {
    var t = document.querySelector('[data-ki-dose-bank] template[data-ki-dose="' + handle + '"]');
    return t && t.content ? t.content.cloneNode(true) : null;
  }

  var buildSeq = 0;
  function buildSwapCards(lines, st) {
    var run = ++buildSeq;
    cards.textContent = '';
    var cardLine = (cards.getAttribute('data-card-line') || '').replace(/\{state\}/g, STATES[st] || st);
    var swapLabel = cards.getAttribute('data-swap-label') || 'Swap';
    lines.forEach(function (line) {
      var sib = (line.handle || '').replace('-infused', '-microdose');
      var lookup = isDn(line.handle) ? Promise.resolve(null) : getProduct(sib);
      lookup.then(function (p) {
        if (run !== buildSeq) return;
        var card = document.createElement('div');
        card.className = 'ccsr__card';
        if (!p) {
          var a = document.createElement('a');
          a.className = 'ccsr__card-line';
          a.href = (cards.getAttribute('data-fallback-url') || '/#shop').replace('#shop', '?formula=cbd-forward#shop');
          a.textContent = 'See the CBD-Forward cans';
          card.appendChild(a);
          cards.appendChild(card);
          return;
        }
        var v = matchVariant(p, line.variant_title);
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          img.alt = ''; img.loading = 'lazy'; img.width = 44; img.height = 64;
          card.appendChild(img);
        }
        var main = document.createElement('div');
        main.className = 'ccsr__card-main';
        var nameEl = document.createElement('p');
        nameEl.className = 'ccsr__card-name';
        nameEl.textContent = p.title + (v && v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
        main.appendChild(nameEl);
        var dose = doseFor(sib);
        if (dose) main.appendChild(dose);
        var lineEl = document.createElement('p');
        lineEl.className = 'ccsr__card-line';
        lineEl.textContent = cardLine + (v ? ' ' + moneyFromCents(v.price) : '');
        main.appendChild(lineEl);
        card.appendChild(main);
        if (v) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'ki-btn ki-btn--block ccsr__btn';
          btn.textContent = swapLabel;
          btn.addEventListener('click', function () { swapLine(btn, v.id, line.key, line.quantity, function () {
            track('state_rescue_swap', { from: line.handle, to: sib });
            announce('Swapped to the CBD-Forward can.');
          }); });
          card.appendChild(btn);
        } else {
          var link = document.createElement('a');
          link.className = 'ccsr__card-line'; link.href = p.url || ('/products/' + sib);
          link.textContent = 'View product';
          card.appendChild(link);
        }
        cards.appendChild(card);
      });
    });
  }
  function refreshDrawer() {
    /* theme.js keeps its renderer private; the header cart trigger's bound
       click (preventDefault + refetch + re-render) is the public path. */
    var t = document.querySelector('[data-cart-open]');
    if (t) { t.click(); } else { window.location.href = '/cart'; }
  }
  function swapLine(btn, addId, key, qty, done) {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: addId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }).then(function (r) {
      if (r && !r.ok) throw new Error('change failed');
      if (done) done();
      refreshDrawer();
    }).catch(function () {
      btn.disabled = false;
      announce('Could not swap. Try again.');
    });
  }

  /* ── Notify-me capture (AJAX with native fallback) ── */
  if (notifyForm) {
    notifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var st = getState();
      var btn = notifyForm.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(notifyForm.action, { method: 'POST', credentials: 'same-origin', body: new FormData(notifyForm) })
        .then(function (r) {
          if (!r.ok) throw new Error('post failed');
          /* bot protection redirects an AJAX /contact post to /challenge: not a signup */
          if (r.redirected && /\/challenge/.test(r.url || '')) throw new Error('challenge');
          track('state_notify_submit', { state: st, placement: 'cart_drawer' });
          Array.prototype.forEach.call(notifyForm.querySelectorAll('.ki-input, .ki-check, [type="submit"]'), function (el) { el.hidden = true; });
          if (notifyNote) notifyNote.textContent = (notifyNote.getAttribute('data-tpl-success') || 'You’re on the list.').replace(/\{state\}/g, STATES[st] || st);
          announce('You’re on the list.');
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          notifyForm.submit();
        });
    });
  }

  /* ── The ONE upsell card ──
     1) a 4-pack line with a bigger rung → the upgrade;
     2) else complete the ritual (one world in the cart);
     3) else an 8 / 12 line → the next-rung upgrade. */
  var ritual = merch.querySelector('[data-ccrit]');
  var ritualCards = ritual ? Array.prototype.slice.call(ritual.querySelectorAll('[data-ccrit-card]')) : [];
  var upgrade = merch.querySelector('[data-ccup]');
  var upBtn = upgrade ? upgrade.querySelector('[data-ccup-swap]') : null;
  var upTitle = upgrade ? upgrade.querySelector('.ccup__title') : null;
  var FROM_PACK = packNum(merch.getAttribute('data-from-pack')) || 4;
  var shopUrl = merch.getAttribute('data-shop-url') || '/#shop';
  var emptyLabel = merch.getAttribute('data-empty-label') || 'Shop the lineup';

  function hideMerch() {
    if (ritual) { ritual.hidden = true; ritualCards.forEach(function (el) { el.hidden = true; }); }
    if (upgrade) upgrade.hidden = true;
  }

  var ritualShownKey = '';
  function showRitual(c) {
    if (!ritual || !ritualCards.length || !c || !c.items || !c.items.length) return false;
    var hasJoe = false, hasTini = false, allCbd = true, hempCount = 0;
    c.items.forEach(function (i) {
      var w = worldOf(i.handle);
      if (!w) return;
      hempCount++;
      if (w === 'joe' || w === 'both') hasJoe = true;
      if (w === 'tini' || w === 'both') hasTini = true;
      if (!/-microdose/.test(i.handle || '')) allCbd = false;
    });
    if (!hempCount || hasJoe === hasTini) return false;
    var st = getState();
    if (st && BANNED.indexOf(st) !== -1) return false;
    var stateCbd = !!(st && BLOCKED10.indexOf(st) !== -1);
    var want = hasJoe ? 'tini' : 'joe';
    var formula = (allCbd || stateCbd) ? 'microdose' : 'infused';
    var pickEl = null;
    ritualCards.forEach(function (el) {
      if (!pickEl && el.getAttribute('data-world') === want && el.getAttribute('data-formula') === formula) pickEl = el;
    });
    if (!pickEl && !stateCbd) {
      ritualCards.forEach(function (el) { if (!pickEl && el.getAttribute('data-world') === want) pickEl = el; });
    }
    if (!pickEl) return false;
    pickEl.hidden = false;
    ritual.hidden = false;
    var key = want + '/' + pickEl.getAttribute('data-formula');
    if (key !== ritualShownKey) track('cart_ritual_shown', { world: want, formula: pickEl.getAttribute('data-formula') });
    ritualShownKey = key;
    return true;
  }

  var upSeq = 0;
  var upState = null;
  function tryUpgrade(line, run) {
    var fromN = packNum(line.variant_title);
    return getProduct(line.handle).then(function (p) {
      if (run !== upSeq || !p || !upgrade || !upBtn) return false;
      var best = null, bestN = 0;
      (p.variants || []).forEach(function (v) {
        var n = packNum(v.title);
        if (v.available !== false && n > fromN && (!best || n < bestN)) { best = v; bestN = n; }
      });
      if (!best || best.id === line.variant_id) return false;
      var delta = Math.round(line.price / fromN - best.price / bestN);   /* live cents per can */
      var map = { a: article(bestN), pack: best.title, price: moneyFromCents(best.price), delta: moneyFromCents(delta), product: p.title };
      var tpl = delta > 0 ? upTitle.getAttribute('data-tpl') : upTitle.getAttribute('data-tpl-alt');
      upTitle.textContent = (tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; });
      upBtn.textContent = (upBtn.getAttribute('data-tpl') || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; });
      upBtn.setAttribute('aria-label', (upBtn.textContent || '').trim() + ', ' + p.title);
      upBtn.disabled = false;
      upState = { line: line, to: best, product: p };
      upgrade.hidden = false;
      track('cart_upgrade_shown', { handle: line.handle, from: line.variant_title, to: best.title, delta_cents: delta });
      return true;
    });
  }

  function computeMerch(c) {
    var run = ++upSeq;
    upState = null;
    hideMerch();
    if (!STORE_OPEN || !c || !c.items || !c.items.length) return;
    var st = getState();
    if (st && BANNED.indexOf(st) !== -1) return;        /* nothing ships there — no upsell */
    var packLines = c.items.filter(function (i) { return !i.selling_plan_allocation && packNum(i.variant_title) > 0; });
    var fromLine = null, laterLines = [];
    packLines.forEach(function (i) {
      var n = packNum(i.variant_title);
      if (n === FROM_PACK && !fromLine) fromLine = i;
      else if (n > FROM_PACK) laterLines.push(i);
    });
    laterLines.sort(function (a, b) { return packNum(a.variant_title) - packNum(b.variant_title); });

    function tryLater(idx) {
      if (idx >= laterLines.length || run !== upSeq) return;
      tryUpgrade(laterLines[idx], run).then(function (ok) { if (!ok && run === upSeq) tryLater(idx + 1); });
    }
    if (fromLine) {
      tryUpgrade(fromLine, run).then(function (ok) {
        if (ok || run !== upSeq) return;
        if (!showRitual(c)) tryLater(0);
      });
      return;
    }
    if (showRitual(c)) return;
    tryLater(0);
  }

  if (upBtn) {
    upBtn.addEventListener('click', function () {
      if (!upState) return;
      var s = upState;
      swapLine(upBtn, s.to.id, s.line.key, s.line.quantity, function () {
        track('cart_upgrade', { handle: s.line.handle, from: s.line.variant_title, to: s.to.title });
        announce('Swapped to the ' + s.to.title + '.');
      });
    });
  }

  /* ── Per-line dose pill (cloned from the Liquid dose bank) ── */
  function decorateLines(c) {
    if (!c || !c.items) return;
    c.items.forEach(function (item) {
      var el = null;
      Array.prototype.forEach.call(cartBody.querySelectorAll('.line'), function (n) { if (n.getAttribute('data-key') === item.key) el = n; });
      if (!el || el.querySelector('[data-kc-dose]')) return;
      var dose = doseFor(item.handle);
      var top = el.querySelector('.line__top');
      if (dose && top) top.parentNode.insertBefore(dose, top.nextSibling);
    });
  }

  /* theme.js prints its own empty-state anchor; keep it on /#shop and ink. */
  function patchEmpty() {
    var a = cartBody.querySelector('.cart__empty a');
    if (!a) return;
    a.href = shopUrl;
    a.className = 'ki-btn';
    a.textContent = emptyLabel;
  }

  /* Ordering closed for the hemp lineup only: apparel-only carts can check
     out; any hemp line shows the "ordering opens soon" note instead. */
  function syncCheckout(c) {
    if (!c || !c.items) return;
    var hemp = hempLines(c).length > 0;
    var root = merch.closest('.cart') || document;
    /* "Packed cold" describes the coffee box: hemp carts only */
    Array.prototype.forEach.call(root.querySelectorAll('[data-kc-hemp-only]'), function (li) { li.hidden = !hemp; });
    if (STORE_OPEN) return;
    var gated = root.querySelector('[data-kc-gated]');
    var closed = root.querySelector('[data-kc-closed]');
    if (gated) gated.hidden = hemp || !c.items.length;
    if (closed) closed.hidden = !hemp;
  }

  var t0 = null;
  function refetch() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; decorateLines(c); compute(); syncCheckout(c); })
      .catch(function () {});
  }
  syncPicker();
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      patchEmpty();
      clearTimeout(t0);
      t0 = setTimeout(refetch, 120);
    }).observe(cartBody, { childList: true });
  }
})();
